import React from "react";

const About = () => {
  return (
    <div>
      <h1>Hello from About page</h1>
      <p>
        This is a React JS app which can be used to search for github users.
      </p>
      <p>Version: 1.0.0</p>
    </div>
  );
};

export default About;
